import React from 'react';
import { connect } from "react-redux";
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import updateUser from './../../../API/Admin/PutUser'
import Loader from './../../../Global/loader'

class UpdateArticle extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
    }

    state={
        loading: true
    }

    componentDidMount = async () => {
        this.setState({
            loading: true
        })

        await this.setState({
            loading: false
        }) 
    }

    
    handleUpdateChange = async (e) => {
        await this.props.mapState("ADMIN_CHANGE_ONE_USER_DETAILS", e.target) 
    }

    submitUpdate = async (e) =>{
        this.setState({ loading: true })
        e.preventDefault()
        let updatePP = await updateUser(this.props.oneClientInfo.uuid, this.props.oneUser)
        if(updatePP.data.data.operationResult === "SUCCESS"){
            store.addNotification({
                title: "Uspješno!",
                message: "Promjena korisnika je izvršena",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
        }
        else(
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom promjene korisnika, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
        )
        this.setState({ loading: false })
        this.props.goBack()
    }

    render(){  
        return (
            <>
                {this.state.loading ?
                    <div style={{position: "sticky", marginTop: "50px", left: "50%"}}>
                        <Loader />
                    </div>
                :

                <form style={{padding: "40px"}}>
                    <div className="row">          
                        <div className="col col-sm-12 col-lg-6 col-md-12">
                            <div className="form-group row">
                                <label htmlFor="username" className="col-sm-4 col-form-label">Korisničko ime</label>
                                <div className="col-sm-8">
                                    <input      
                                            id="username"                          
                                            type="text"
                                            value={this.props.oneUser.username}
                                            onChange={e => this.handleUpdateChange(e)}
                                        />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="email" className="col-sm-4 col-form-label">E-mail</label>
                                <div className="col-sm-8">
                                    <input
                                        id="email"  
                                        type="text"
                                        value={this.props.oneUser.email}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="firstName" className="col-sm-4 col-form-label">Ime</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="firstName"                         
                                        type="text"
                                        value={this.props.oneUser.firstName}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div>  

                            <div className="form-group row">
                                <label htmlFor="lastName" className="col-sm-4 col-form-label">Prezime</label>
                                <div className="col-sm-8">
                                    <input  
                                        id="lastName"                         
                                        type="text"
                                        value={this.props.oneUser.lastName}
                                        onChange={e => this.handleUpdateChange(e)}
                                    />
                                </div>
                            </div> 

                            <div className="col-sm-4" style={{float:"right",padding: "0px"}}>
                                <button                                     
                                    className="btn btn-info" 
                                    style={{padding:"10px"}} 
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    Spremi
                                </button>
                            </div>                                  
                        </div>                        
        
                        
                    </div>           
                    
                    <div 
                        className="btn btn-default" 
                        style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                        onClick={(e) => this.props.goBack(e)}
                    >
                        <BsBackspaceFill size={30} />  <strong>Nazad</strong>
                    
                    </div>    
                
                </form>
                }        
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        oneUser: state.adminClient.oneUser
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(UpdateArticle);


